import styled from 'styled-components';
import { ReactComponent as Logo } from '../../BlackLogo.svg';

const CustomHeader = styled.div`

`;

function HeaderName() {
	return (
		<>
			<CustomHeader><Logo /></CustomHeader>
		</>
	);
}

export default HeaderName;
